import { render, staticRenderFns } from "./RubricList.vue?vue&type=template&id=075abf9b"
import script from "./RubricList.vue?vue&type=script&lang=js"
export * from "./RubricList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports